// biome-ignore lint/style/useImportType: it wants react for some reason
import React from "react";
import {
  Link as RACLink,
  type LinkProps as RACLinkProps,
} from "react-aria-components";
import { tv } from "tailwind-variants";

import { composeTailwindRenderProps } from "@/components/ui/utils";

export const linkStyles = tv({
  base: "forced-colors:outline-[Highlight] focus-visible:outline-2 outline outline-offset-1 disabled:focus-visible:outline-0 outline-0 outline-ring/70 rounded disabled:opacity-60 forced-colors:disabled:text-[GrayText] border-transparent transition-colors disabled:cursor-default",
  variants: {
    intent: {
      unstyled: "text-foreground",
      primary:
        "text-primary hover:text-primary/80 forced-colors:disabled:text-[GrayText]",
      danger:
        "text-destructive hover:text-destructive/80 forced-colors:disabled:text-[GrayText]",
      "lad/primary":
        "text-foreground hover:text-primary dark:hover:text-primary/80 forced-colors:disabled:text-[GrayText]",
      secondary: "text-secondary-foreground hover:text-secondary-foreground/80",
    },
  },
  defaultVariants: {
    intent: "unstyled",
  },
});

export type LinkProps = RACLinkProps & {
  intent?: "primary" | "secondary" | "danger" | "lad/primary" | "unstyled";
  ref?: React.Ref<HTMLAnchorElement>;
};

export function Link({ className, ref, ...props }: LinkProps) {
  return (
    <RACLink
      ref={ref}
      aria-label={props["aria-label"] ?? "Link"}
      {...props}
      className={composeTailwindRenderProps(
        className,
        linkStyles({ intent: props.intent }),
      )}
    />
  );
}
